import {Injectable, Pipe} from '@angular/core';

import moment from 'moment';
//import upperFirst from 'lodash/upperFirst';

@Pipe({
  name: 'humanizeDate',
  pure: false
})
@Injectable()
export class HumanizeDate {
  result: string = '';
  transform(value: string) {
    var $this = this;
    if(value) {
      $this.result = moment(value, 'X').fromNow();
      // $this.result = moment(value).calendar(null, {
      //     sameDay: 'h:mm a',
      //     nextDay: '[Tomorrow]',
      //     nextWeek: 'dddd',
      //     lastDay: '[Yesterday]',
      //     lastWeek: '[Last] dddd',
      //     sameElse: 'MM/DD/YYYY'
      // });
      return $this.result;
    }
  }
}

@Pipe({
  name: 'pickTime'
})
@Injectable()
export class PickTime {

  transform(value: string) {
    if(value) {
      return moment(new Date(value)).format('h:mm a');
    }
  }
}

@Pipe({
  name: 'pickDate'
})
@Injectable()
export class PickDate {

  transform(value: string) {
    if(value) {
      return moment(value, 'X').format('DD MMM YYYY');
    }
  }
}

@Pipe({
  name: 'articleDate'
})
@Injectable()
export class ArticleDate {

  transform(value: string) {
    if(value) {
      return moment(value, 'X').format('DD-MM-YY');
    }
  }
}

@Pipe({
  name: 'formatTime'
})
@Injectable()
export class FormatTime {

  transform(value: string) {
    if(value) {
      return moment(value, ["HH:mm"]).format("h:mm A");
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/humanize-date.ts